import { createFollowerData, deleteFollowerData } from "@/api/followers";
import SolidButton from "@/components/ui/Buttons/SolidButton";
import { useAuthContext } from "@/context/auth/useAuthContext";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import PostDetailsControls from "../content-details-controls";
import UserUnfollowBtn from "@/components/user-profile-comps/user-unfollow-btn";
import { useTranslations } from "@/lib/static-intl";
import { usePathname } from "next/navigation";
import { EVENT_TYPES, sendAnalyticsEvent } from "@/utils/AnalyticsEvents";

const PostDetailUserFollowBtn = ({
  selectedPostInModal,
  currentUserFollowing,
  setCurrentUserFollowing,
  setSelectedPostInModal,
  setAllPosts,
  closePopup,
  openDeletePostWarningModal,
}) => {
  const apiT = useTranslations("api");
  const pathName = usePathname();
  const explorePostDetailsT = useTranslations("explore.explore_post_details");

  const { user, openLoginModal } = useAuthContext();
  const [loader, setLoader] = useState(false);

  const unfollowThisUser = async (userIdToBeUnfollowed) => {
    if (!user) {
      openLoginModal();
      return;
    }
    const id = currentUserFollowing.find(
      (_f) => _f?.userId === userIdToBeUnfollowed
    )?.id;

    if (!id) return;
    try {
      setLoader(true);
      await deleteFollowerData(id);

      setCurrentUserFollowing(
        currentUserFollowing.filter((_f) => _f?.userId !== userIdToBeUnfollowed)
      );
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.message ||
        error?.message ||
        apiT("error message"),
        {
          variant: "error",
        }
      );
    } finally {
      setLoader(false);
    }
  };

  const followThisUser = async (userIdToBeFollowed) => {
    if (!user) {
      openLoginModal();
      return;
    }
    if (!userIdToBeFollowed) return;
    try {
      setLoader(true);
      const payload = {
        followingId: userIdToBeFollowed,
        followerId: user?.userId,
      };
      const response = await createFollowerData(payload);
      sendAnalyticsEvent(EVENT_TYPES.newFans, userIdToBeFollowed);
      setCurrentUserFollowing([
        ...currentUserFollowing,
        {
          id: response?.id,
          userId: userIdToBeFollowed,
        },
      ]);
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.message ||
        error?.message ||
        apiT("error message"),
        {
          variant: "error",
        }
      );
    } finally {
      setLoader(false);
    }
  };
  return (
    <div>
      {user?.userId === selectedPostInModal?.user?.id || pathName === "/notify" ? (
        <PostDetailsControls
          closePopup={closePopup}
          setAllPosts={setAllPosts}
          selectedPostInModal={selectedPostInModal}
          setSelectedPostInModal={setSelectedPostInModal}
          openDeletePostWarningModal={openDeletePostWarningModal}
        />
      ) : (
        <div
          className={`${user?.userId === selectedPostInModal?.user?.id && "invisible"
            }`}
        >
          {currentUserFollowing?.find(
            (_f) => _f?.userId === selectedPostInModal?.user?.id
          ) ? (
            // <SolidButton
            //   className={`!py-1.5 !bg-transparent !border !text-black transition ease-in-out ${loader && "cursor-not-allowed opacity-60"
            //     }`}
            //   onClick={() => unfollowThisUser(selectedPostInModal?.user?.id)}
            //   loading={loader}
            //   disabled={loader}
            // >
            //   Unfollow
            // </SolidButton>
            <UserUnfollowBtn
              className={`!py-1.5 !bg-transparent !border !text-black dark:!text-white transition ease-in-out ${loader && "cursor-not-allowed opacity-60"
                }`}
              loader={loader}
              disabled={loader}
              onClick={() => unfollowThisUser(selectedPostInModal?.user?.id)}
            />
          ) : (
            <SolidButton
              className={`!py-1.5 transition ease-in-out ${loader && "cursor-not-allowed opacity-60"
                }`}
              onClick={() => followThisUser(selectedPostInModal?.user?.id)}
              loading={loader}
              disabled={loader}
            >
              {explorePostDetailsT("follow")}
            </SolidButton>
          )}
        </div>
      )}
    </div>
  );
};

export default PostDetailUserFollowBtn;
